<script setup>
import { reactive, computed } from 'vue';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useI18n } from 'vue-i18n';

import Input from 'next/input/Input.vue';
import TextAreaNext from 'next/textarea/TextArea.vue';

const props = defineProps({
  stage: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const rules = {
  name: {
    required,
  },
  description: {
    required,
  },
};

const state = reactive({
  name: props.stage.name ?? '',
  description: props.stage.description ?? '',
});

const v$ = useVuelidate(rules, state);

const nameErrorMessage = computed(() => {
  if (!v$.value.name.$error) return '';
  return t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.EDIT.FORM.NAME.ERROR');
});

const descriptionErrorMessage = computed(() => {
  if (!v$.value.description.$error) return '';
  return t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.EDIT.FORM.DESCRIPTION.ERROR');
});

const prepareFormData = () => {
  return {
    name: state.name,
    description: state.description,
  };
};

const validate = async () => {
  const isFormValid = await v$.value.$validate();
  if (!isFormValid) return null;

  return prepareFormData();
};

defineExpose({
  state,
  validate,
});
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="validate">
    <Input
      v-model.trim="state.name"
      :label="$t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.EDIT.FORM.NAME.LABEL')"
      type="text"
      :message="nameErrorMessage"
      :message-type="nameErrorMessage ? 'error' : 'info'"
    />

    <TextAreaNext
      v-model.trim="state.description"
      :label="
        $t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.EDIT.FORM.DESCRIPTION.LABEL')
      "
      custom-text-area-class="!outline !outline-0 min-h-[10rem]"
      resize
      :message="descriptionErrorMessage"
      :message-type="descriptionErrorMessage ? 'error' : 'info'"
    />
  </form>
</template>
